export const colorMap = {
  0:{
    '--primary-survey':'#14cc52',
    '--primary-selected-bg-survey':'#ebfff1',
    '--primary-hover-survey':'#3fd973',
    '--primary-click-survey':'#0fb346',
    '--primary-disabled-survey':'#dbffe7',
    '--primary-checked-survey':'#14cc52',
    '--border-radius-button-survey':'6px',
    '--border-radius-input-survey':'6px',
    '--line-color-survey':'#14cc52',
    '--line-height-survey':'2px',
    '--check-box-item-input-margin':'0 0 0 12px',
    '--check-box-item-input-block':'inline-block',
    '--topic-content-item-padding':'24px',
    '--button-height':'32px',
    '--one-page-button-flex-direction':'row',
    '--one-page-button-flex':'1',
    '--one-page-button-padding':' 0 0 0 10px',
    '--last-page-button-color':'#fff',
    '--last-page-button-bgcolor':'#14cc52',
    '--last-page-button-border-color':'#14cc52',
    '--last-page-button-bgcolor-hover':'#3fd973',
    '--topic-title-font-weight':'500',
    '--check-border-radius':'4px',
    '--one-page-submit-left':'10px',
    '--one-page-submit-top':'0px',
    '--topicName-padding-bottom':'24px',
    '--topicName-margin-bottom':'24px',
  },//oppo主题
  1:{
    '--primary-survey':'#14cc52',
    '--primary-selected-bg-survey':'#ebfff1',
    '--primary-hover-survey':'#3fd973',
    '--primary-click-survey':'#0fb346',
    '--primary-disabled-survey':'#dbffe7',
    '--primary-checked-survey':'#14cc52',
    '--border-radius-button-survey':'6px',
    '--border-radius-input-survey':'6px',
    '--line-color-survey':'#14cc52',
    '--line-height-survey':'2px',
    '--check-box-item-input-margin':'0 0 0 12px',
    '--check-box-item-input-block':'inline-block',
    '--topic-content-item-padding':'24px',
    '--button-height':'32px',
    '--one-page-button-flex-direction':'row',
    '--one-page-button-flex':'1',
    '--one-page-button-padding':' 0 0 0 10px',
    '--last-page-button-color':'#14cc52',
    '--last-page-button-bgcolor':'#FFF',
    '--last-page-button-border-color':'#14cc52',
    '--last-page-button-bgcolor-hover':'#14cc52',
    '--topic-title-font-weight':'500',
    '--check-border-radius':'4px',
    '--one-page-submit-left':'10px',
    '--one-page-submit-top':'0px',
    '--topicName-padding-bottom':'24px',
    '--topicName-margin-bottom':'24px',
  },//中秋主题
  2:{
    '--primary-survey':'#14cc52',
    '--primary-selected-bg-survey':'#ebfff1',
    '--primary-hover-survey':'#3fd973',
    '--primary-click-survey':'#0fb346',
    '--primary-disabled-survey':'#dbffe7',
    '--primary-checked-survey':'#14cc52',
    '--border-radius-button-survey':'6px',
    '--border-radius-input-survey':'6px',
    '--line-color-survey':'#14cc52',
    '--line-height-survey':'2px',
    '--check-box-item-input-margin':'0 0 0 12px',
    '--check-box-item-input-block':'inline-block',
    '--topic-content-item-padding':'24px',
    '--button-height':'32px',
    '--one-page-button-flex-direction':'row',
    '--one-page-button-flex':'1',
    '--one-page-button-padding':' 0 0 0 10px',
    '--last-page-button-color':'#14cc52',
    '--last-page-button-bgcolor':'#FFF',
    '--last-page-button-border-color':'#14cc52',
    '--last-page-button-bgcolor-hover':'#14cc52',
    '--topic-title-font-weight':'500',
    '--check-border-radius':'4px',
    '--one-page-submit-left':'10px',
    '--one-page-submit-top':'0px',
    '--topicName-padding-bottom':'24px',
    '--topicName-margin-bottom':'24px',
  },//国庆主题
  3:{
    '--primary-survey':'#FF5B00',
    '--primary-selected-bg-survey':'rgba(225,91,0,0.1)',
    '--primary-hover-survey':'#FF5B00',
    '--primary-click-survey':'#FF5B00',
    '--primary-disabled-survey':'#FF5B00',
    '--primary-checked-survey':'#FF5B00',
    '--border-radius-button-survey':'6px',
    '--border-radius-input-survey':'6px',
    '--line-color-survey':'#FF5B00',
    '--check-box-item-input-margin':'0 0 0 12px',
    '--check-box-item-input-block':'inline-block',
    '--topic-content-item-padding':'24px',
    '--button-height':'32px',
    '--one-page-button-flex-direction':'row',
    '--one-page-button-flex':'1',
    '--one-page-button-padding':' 0 0 0 10px',
    '--last-page-button-color':'#FFF',
    '--last-page-button-bgcolor':'#FF5B00',
    '--last-page-button-border-color':'#FF5B00',
    '--last-page-button-bgcolor-hover':'#FF5B00',
    '--topic-title-font-weight':'500',
    '--check-border-radius':'4px',
    '--one-page-submit-left':'10px',
    '--one-page-submit-top':'0px',
    '--topicName-padding-bottom':'24px',
    '--topicName-margin-bottom':'24px',
  },//元旦主题
  4:{
    '--primary-survey':'black',
    '--primary-selected-bg-survey':'rgb(235,235,235)',
    '--primary-hover-survey':'rgb(51,51,51)',
    '--primary-click-survey':'black',
    '--primary-disabled-survey':'rgb(204,204,204)',
    '--primary-checked-survey':'black',
    // '--primary-selected-bg':''
    '--info-selected-bg-survey':'rgb(235,235,235)',
    '--info-hover-survey':'rgb(235,235,235)',
    '--info-click-survey':'rgb(235,235,235)',
    '--info-disabled-survey':'rgb(204,204,204)',
    //border-radius
    '--border-radius-button-survey':'20px',
    '--border-radius-input-survey':'10px',
    '--line-color-survey':'#14cc52',
    '--line-height-survey':'2px',
    '--check-box-item-input-margin':'0 0 0 12px',
    '--check-box-item-input-block':'inline-block',
    '--topic-content-item-padding':'24px',
    '--button-height':'32px',
    '--one-page-button-flex-direction':'row',
    '--one-page-button-flex':'1',
    '--one-page-button-padding':' 0 0 0 10px',
    '--last-page-button-color':'#FFF',
    '--last-page-button-bgcolor':'black',
    '--last-page-button-border-color':'black',
    '--last-page-button-bgcolor-hover':'rgb(51,51,51)',
    '--topic-title-font-weight':'500',
    '--check-border-radius':'4px',
    '--one-page-submit-left':'10px',
    '--one-page-submit-top':'0px',
    '--topicName-padding-bottom':'24px',
    '--topicName-margin-bottom':'24px',
  },//oppo官网
  5:{
    '--primary-survey':'black',
    '--primary-selected-bg-survey':'rgb(235,235,235)',
    '--primary-hover-survey':'rgb(51,51,51)',
    '--primary-click-survey':'black',
    '--primary-disabled-survey':'rgb(204,204,204)',
    '--primary-checked-survey':'red',
    // '--primary-selected-bg':''
    '--info-selected-bg-survey':'rgb(235,235,235)',
    '--info-hover-survey':'rgb(235,235,235)',
    '--info-click-survey':'rgb(235,235,235)',
    '--info-disabled-survey':'rgb(204,204,204)',
    //border-radius
    '--border-radius-button-survey':'2px',
    '--border-radius-input-survey':'2px',
    '--line-color-survey':'#EAEAEA',
    '--line-height-survey':'1px',
    '--check-box-item-input-margin':'10px 0 0 0',
    '--check-box-item-input-block':'block',
    '--topic-content-item-padding':'24px 16px',
    '--one-page-button-height':'40px',
    '--one-page-button-flex-direction':'column',
    '--one-page-button-flex':'none',
    '--one-page-button-padding':' 12px 0 0 0',
    '--last-page-button-color':'black',
    '--last-page-button-bgcolor':'#fff',
    '--last-page-button-border-color':'black',
    '--last-page-button-bgcolor-hover':'rgb(235,235,235,0.7)',
    '--topic-title-font-weight':'400',
    '--check-border-radius':'0px',
    '--one-page-submit-left':'0px',
    '--one-page-submit-top':'10px',
    '--topicName-padding-bottom':'8px',
    '--topicName-margin-bottom':'0px',
  }//一加官网
}
